module.exports = __webpack_public_path__ + "static/media/aac.77098f82.png";